// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cA20P","colBig":"styles_colBig__14OVk","colSmall":"styles_colSmall__UkkmF","shopifyNameWrapper":"styles_shopifyNameWrapper__3K8Hp"};